export const GIT = {
  GIT_REPO_NAME: 'react-play',
  GIT_REPO_USER: 'reactplay',
  GIT_API_BASE_URL: 'https://api.github.com'
};
